import { useHeadingRef } from "@/lib/barTitle";

export const PageHeader = ({ eyebrow, title, subtitle, children, testid, stack = false }) => {
  const ref = useHeadingRef(title, eyebrow);
  return (
    <div className={stack ? "mb-8 flex flex-col gap-5" : "mb-10 flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between"}>
      <div>
        {eyebrow && <p className="mb-2 text-[10px] font-semibold uppercase tracking-[0.22em] text-amber-700">{eyebrow}</p>}
        <h1 ref={ref} className="font-heading text-4xl font-bold tracking-tight text-zinc-900 sm:text-5xl" data-testid={testid}>{title}</h1>
        {subtitle && <div className="mt-2 text-sm text-zinc-500" data-testid={testid ? `${testid}-subtitle` : undefined}>{subtitle}</div>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-3" data-testid={testid ? `${testid}-tools` : undefined}>{children}</div>}
    </div>
  );
};

export const EmptyState = ({ icon: Icon, title, text, action }) => (
  <div className="flex flex-col items-start gap-4 rounded-lg border border-dashed border-zinc-300 bg-white/60 px-8 py-14" data-testid="empty-state">
    {Icon && <Icon size={28} strokeWidth={1.25} className="text-zinc-400" />}
    <div>
      <p className="font-heading text-xl font-semibold">{title}</p>
      <p className="mt-1 max-w-md text-sm text-zinc-500">{text}</p>
    </div>
    {action}
  </div>
);
